/* eslint-disable @stylistic/indent */

export const useCustomJsonldPoint = function (seoInfo) {
    const breadCrumb = seoInfo?.breadCrumbList || []
    useJsonld(() => (
        [{
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            'itemListElement': [
                {
                    '@type': 'ListItem',
                    'position': 1,
                    'item': {
                        '@id': 'https://weathernews.jp/',
                        'name': 'トップ'
                    }
                },
                ...breadCrumb.map((item, index) => {
                    const origin = (import.meta.client) ? window.location.origin : 'https://weathernews.jp'
                    const path = origin + item?.link
                    return {
                        '@type': 'ListItem',
                        'position': index + 2,
                        'item': {
                            ...(item.link ? { '@id': new URL(path) } : {}),
                            name: item.text
                        }
                    }
                })
            ]
        }
        ]
    ))
}
